import React from "react";
import { MdCalendarMonth } from "react-icons/md";

const PageLayout = ({
  children,
  title,
  subtitle,
  icon: Icon = MdCalendarMonth,
  actions,
}) => {
  return <div className="mx-auto px-4 py-8 sm:px-6 lg:px-8">{children}</div>;
};

export default PageLayout;
